<ng-container *transloco="let t">
  <div class="w-full h-full relative flex flex-col min-h-0">
    @if(service.working()) {
    <mat-progress-bar class="absolute! inset-x-0! top-0! h-0.5! z-30!" mode="indeterminate"></mat-progress-bar>
    }

    @if(service.model(); as file) {
    <div class="flex flex-row items-center gap-2 py-2 px-3">
      <button mat-icon-button class="block lg:hidden!" (click)="close()">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div class="flex items-center gap-2 min-w-0">
        @if(file.code) {
        <span class="text-xs opacity-60">#{{ file.code }}</span>
        }
        <app-status-badge [status]="file.status"></app-status-badge>
      </div>

      <span class="flex-1"></span>

      <div class="flex flex-row items-center gap-1">
        @if(service.canDownload(file)) {
        <button mat-flat-button color="primary" [disabled]="service.working()" (click)="service.download(file)">
          {{ t('Download') }}
        </button>
        }

        <button mat-icon-button [matMenuTriggerFor]="menu1">
          <i-tabler name="dots-vertical" class="size-5! flex"></i-tabler>
        </button>

        <button mat-icon-button [disabled]="service.working()" (click)="close()" class="hidden! lg:block!">
          <i-tabler name="x" class="size-5! flex"></i-tabler>
        </button>

        <mat-menu #menu1="matMenu" class="cardWithShadow">
          @if(file.id) {
          <button mat-menu-item [disabled]="service.working()" (click)="service.getById(file.id!)">
            <div class="flex items-center gap-4">
              <i class="iconify text-2xl opacity-80" data-icon="solar:refresh-outline"></i>
              <span>{{ t('Reload') }}</span>
            </div>
          </button>
          }

          @if(file.publicUrl) {
          <mat-divider></mat-divider>

          <button mat-menu-item (click)="service.copyPublicUrl(file)">
            <div class="flex items-center gap-4">
              <i class="iconify text-2xl opacity-80" data-icon="solar:copy-linear"></i>
              <span>{{ t('Copy URL') }}</span>
            </div>
          </button>
          }
        </mat-menu>
      </div>
    </div>

    <ng-scrollbar class="relative flex-1 min-h-0 p-4 gap-4">

      <!-- Arquivo -->
      <div class="mb-6">
        <h5 class="mb-1 truncate">{{ file.originalName }}</h5>
        <p class="text-sm opacity-60 mb-4">{{ file.type?.name || file.contentType }}</p>
        <div class="border border-border rounded-xl overflow-hidden">
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Size') }}</span>
            <span class="text-sm font-medium">{{ formatBytes(file.sizeBytes) }}</span>
          </div>
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">MIME</span>
            <span class="text-sm font-medium break-all text-right">{{ file.contentType }}</span>
          </div>
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Version') }}</span>
            <span class="text-sm font-medium">v{{ file.version }}</span>
          </div>
          <div class="flex items-center justify-between gap-4 px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground shrink-0">{{ t('File Key') }}</span>
            <span class="text-sm font-medium break-all text-right">{{ file.key }}</span>
          </div>
          <div class="flex items-center justify-between gap-4 px-4 py-2.5">
            <span class="text-sm text-muted-foreground shrink-0">{{ t('Public URL') }}</span>
            @if(file.publicUrl) {
            <a class="text-sm font-medium text-primary hover:underline break-all text-right"
              [href]="file.publicUrl" target="_blank" rel="noopener">{{ file.publicUrl }}</a>
            } @else {
            <span class="text-sm font-medium">—</span>
            }
          </div>
        </div>
      </div>

      <!-- Localização -->
      <div class="mb-6">
        <h5 class="mb-4">{{ t('Location') }}</h5>
        <div class="border border-border rounded-xl overflow-hidden">
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Storage') }}</span>
            <span class="text-sm font-medium">{{ file.storage?.name || '—' }}</span>
          </div>
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Folder') }}</span>
            <span class="text-sm font-medium">{{ file.folder?.name || '—' }}</span>
          </div>
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Feature') }}</span>
            <span class="text-sm font-medium">{{ file.feature?.name || '—' }}</span>
          </div>
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Parent Code') }}</span>
            <span class="text-sm font-medium">
              @if(file.parentCode) { {{ file.parentCode }} @if(file.parentName) { · {{ file.parentName }} } } @else { — }
            </span>
          </div>
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Parent Document') }}</span>
            <span class="text-sm font-medium">
              @if(file.parentDocumentNumber) { {{ file.parentDocumentType?.name }} {{ file.parentDocumentNumber }} } @else { — }
            </span>
          </div>
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Group') }}</span>
            <span class="text-sm font-medium">{{ file.group?.name || '—' }}</span>
          </div>
          <div class="flex items-center justify-between px-4 py-2.5">
            <span class="text-sm text-muted-foreground">{{ t('Origin') }}</span>
            <span class="text-sm font-medium">{{ file.origin?.name || '—' }}</span>
          </div>
        </div>
      </div>

      <!-- Log -->
      <div class="mb-6">
        <h5 class="mb-4">{{ t('Log') }}</h5>
        <div class="border border-border rounded-xl overflow-hidden">
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Description') }}</span>
            <span class="text-sm font-medium">{{ file.description || '—' }}</span>
          </div>
          @if(file.expiresAt) {
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Expires At') }}</span>
            <span class="text-sm font-medium">{{ file.expiresAt | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>
          }
          @if(file.retentionUntil) {
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Retention Until') }}</span>
            <span class="text-sm font-medium">{{ file.retentionUntil | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>
          }
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Created At') }}</span>
            <span class="text-sm font-medium">{{ file.log?.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Created By') }}</span>
            <span class="text-sm font-medium">{{ file.log?.createdBy?.name }}</span>
          </div>
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Updated At') }}</span>
            <span class="text-sm font-medium">{{ file.log?.updatedAt | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <div class="flex items-center justify-between px-4 py-2.5 border-b border-border">
            <span class="text-sm text-muted-foreground">{{ t('Updated By') }}</span>
            <span class="text-sm font-medium">{{ file.log?.updatedBy?.name }}</span>
          </div>
          <div class="flex items-center justify-between px-4 py-2.5">
            <span class="text-sm text-muted-foreground">{{ t('Record Version') }}</span>
            <span class="text-sm font-medium">{{ file.log?.recordVersion }}</span>
          </div>
        </div>
      </div>

    </ng-scrollbar>
    }
  </div>
</ng-container>
